export const ScrollTo = (element, offset = 0, duration = 500) => {
  $('html, body').animate({
    scrollTop: element.offset().top - offset
  }, duration);
};
